module.exports = __webpack_public_path__ + "static/media/tcaTile2.2e17cce1.png";